import { baseFetch } from "./base";

export const getLogo = async () => {
  try {
    const response = await baseFetch.get("/logo");
    return response.data;
  } catch (error: unknown) {
    if (error instanceof Error) {
      console.error("Error while fetching logo:", error.message);
    } else {
      console.error("Unexpected error:", error);
    }
    return null;
  }
};